import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { I18n } from 'react-redux-i18n'
import { get } from 'redux/centers/actions'
import SelectBrandsDelegations from './SelectBrandsDelegations'
import './styles.scss'

function displayAllTag(role, optionsWithoutAll) {
  if (['admin', 'root', 'owner'].includes(role)) {
    if (!optionsWithoutAll) return  [{ _id:'all', name: I18n.t('dashboard_all-plural-female'), brand: 'all' }]
  }

  return []
}

/**
 * Select brand and delegations with fixed options in select
 * @param {object} props
 * @param {[{_id: string, name: string}]} props.currentBrands
 * @param {[{_id: string, name: string, brand: string}]} props.currentDelegations
 * @param {function} props.onChange
 */
const MultiBrandsAndDelegations = (props) => {
  const {
    customClassNameContainer,
    multiple = true,
    label,
    placeholder,
    isClearable = false,
    currentBrands = [],
    currentDelegations = [],
    newBrands = [],
    newDelegations = [],
    optionsWithoutAll,
    onChange,
    otherTooltipProps = {}
  } = props

  const dispatch = useDispatch()

  const centers = useSelector((store) => (store.centers))
  const user = useSelector((store) => (store.user))
  const [brands, setBrands] = useState(centers.brands || [])
  const [delegations, setDelegations] = useState(centers.delegations || [])
  const [brandsDelegationsOptions, setBrandsDelegationsOptions] = useState([])

  useEffect(()=>{
    if (centers?.isPending) {
      dispatch(get())
    } else {
      newBrands.length === 0 && setBrands(([...displayAllTag(user.role, optionsWithoutAll)]).concat(centers.brands))
      newDelegations.length === 0 && setDelegations(([...displayAllTag(user.role, optionsWithoutAll)]).concat(centers.delegations))
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [centers])

  useEffect(()=>{
    newBrands.length > 0 && setBrands(([...displayAllTag(user.role, optionsWithoutAll)]).concat(newBrands))
    newDelegations.length > 0 && setDelegations(([...displayAllTag(user.role, optionsWithoutAll)]).concat(newDelegations))
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [newBrands, newDelegations])

  useEffect(()=>{
    const newItemsBrands = deleteItemAll(brands)
    const newItemsDelegations = deleteItemAll(delegations)
    const newOptions = []
    newOptions.push({
      value: 'all',
      label: '',
      isChecked: false,
      delegations: newItemsDelegations
    })
    for(let brand of newItemsBrands){
      const delegationsValue = []
      const isCheckedBrand = currentBrands.some((cb) => cb.value === brand._id)
      for (let delegation of newItemsDelegations){
        const isChecked = currentDelegations.some((cd) => cd.value === delegation._id)
        if (brand._id === delegation.brand)
          delegationsValue.push({ value: delegation._id, label: delegation.name, isChecked })
      }
      if(delegationsValue.length > 0)
        newOptions.push({
          value: brand._id,
          label: brand.name,
          isChecked:isCheckedBrand,
          delegations: delegationsValue
        })
    }

    setBrandsDelegationsOptions(newOptions)
  }, [brands, currentBrands, currentDelegations, delegations])

  const deleteItemAll = (items=[]) =>{
    const index = items.findIndex(item => item._id === 'all')
    if(index >= 0)
      items.splice(index, 1)
    return items
  }

  return (
    <div
      className={`
        wrapper-mode-2
        ${customClassNameContainer ? customClassNameContainer : ''}
      `}
    >
      <SelectBrandsDelegations
        multiple={multiple}
        label={label}
        options={brandsDelegationsOptions}
        brands={currentBrands}
        delegations={currentDelegations}
        placeholder={placeholder}
        onChange={onChange}
        isClearable={isClearable}
        totalDelegations={delegations.length}
        selectDelegations={currentDelegations.length}
        otherTooltipProps={otherTooltipProps}
      />
    </div>
  )
}

export default MultiBrandsAndDelegations
